interface DefectImageMetadata {
  file_url?: string | null;
  path?: string | null;
  url?: string | null;
  created_at?: string | null;
  uploaded_by_id?: string | null;
  file_type?: string | null;
  file_size?: number | null;
  is_creation_photo?: boolean | null;
  is_resolution_photo?: boolean | null;
  [key: string]: unknown;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function getDefectImagePath(value: unknown): string | null {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  if (!isRecord(value)) return null;

  for (const key of ["file_url", "path", "url", "storage_path"]) {
    const candidate = value[key];
    if (typeof candidate === "string" && candidate.trim().length > 0) {
      return candidate.trim();
    }
  }

  return null;
}

export function normalizeDefectImagePaths(images: unknown): string[] {
  if (!images) return [];

  const values = Array.isArray(images) ? images : [images];
  return values.map(getDefectImagePath).filter((path): path is string => !!path);
}
